export default __webpack_public_path__ + "static/media/jackpot-mobile-cn.f106847d.webp";